import { deleteDpopKey } from './dpop-key-store';
import { resetDpopSession } from './dpop-session';

/**
 * Sign-out drops the DPoP key along with the session, so the next contact to sign in on this browser
 * gets a key of their own. The key lives in IndexedDB, which the portal's localStorage.clear() does not
 * touch. Kept apart from dpop-authorization (which needs authService) so msal-service and url-helper can
 * call it without an import cycle. Best effort and time-boxed: it must never delay or block sign-out.
 */
export async function clearDpopState(): Promise<void> {
    if (import.meta.env.VITE_dpopEnabled !== 'true') return;
    resetDpopSession();
    try {
        await Promise.race([deleteDpopKey(), new Promise((resolve) => setTimeout(resolve, 1500))]);
    } catch (error) {
        console.warn('Could not delete the DPoP key on sign-out', error);
    }
}
